import { useState, useCallback } from "react";

export default function usePost({ mtnFunc, onError, onSuccess }) {
  const [error, setError] = useState();
  const [success, setIsSuccess] = useState();
  const [loading, setIsLoading] = useState(false);
  const [isReset, setIsReset] = useState(false);

  const post = useCallback(
    async (body) => {
      reset();
      setIsLoading(true);
      try {
        if (body == null) {
          body = {};
        }
        const res = await mtnFunc(body);
        if (onSuccess != null) {
          onSuccess(res.data);
        }
      } catch (err) {
        console.log(err);
        setError(err);
        if (onError != null) {
          onError(err);
        }
      }
      setIsLoading(false);
    },
    [mtnFunc, onSuccess, onError]
  );

  const reset = () => {
    setError();
    setIsSuccess();
    setIsLoading();
    setIsReset();
  };

  return { post, reset, error, success, loading };
}
